import { MenuItem } from '@mui/material'
import { HardResetTaskDialogV2 } from 'components/pages/task/details/task-content-v2/common/HardResetTaskDialogV2'
import { TaskValue } from 'lib/actions/task'
import { useSimpleModal } from 'lib/modals'
import React, { FC } from 'react'
import { FormattedMessage } from 'react-intl'

type HardResetTaskDropdownOptionProps = {
    task: TaskValue
    close: () => void
}

export const HardResetTaskDropdownOption: FC<HardResetTaskDropdownOptionProps> = ({ task, close }) => {
    const { open } = useSimpleModal()
    const handleClick = (): void => {
        open(HardResetTaskDialogV2, { task })()
        close()
    }

    return (
        <MenuItem onClick={handleClick} key={`components_task_actions_dropdown_hard_reset_task_${task.id}`}>
            <FormattedMessage id="components_task_actions_dropdown_hard_reset_task" defaultMessage="Hard reset" />
        </MenuItem>
    )
}
